<div id="WitnessNotes" class="modal is-touch is-short  without-blur" [ngClass]="{'is-open': (isWitnessDiscrepancyModalOpen | async)}"
  (transitionend)="setDefaultFocus($event)">
  @if (modalOpenStatus && currentWitnessItem | async; as currentItem) {
    <div id="witnessNotesDiv" class="modal__content">
      <absg-spinner id="witnessDiscrepancySpinner" [show]="isSpinnerVisible"></absg-spinner>
      <form [formGroup]="witnessForm" class="height100 flex flex-column">
        <div class="modal__header">
          <div class="h2 gray-40 mb1" id="headerQOH">QOH Discrepancy</div>
          <div class="modal__card border border-navy-87">
            <div class="row no-gutters">
              <div class="col-8 border-right border-navy-87">
                <div class="flex myn1 pb1">
                  <absg-icons [customId]="'witnessDiscrepancyIcons'" [isAuditFavorite]="false" [isTitle]="true" [iconProvider]="currentItem"
                    [suppressFavoriteIcon]="currentItem.isBinned()"></absg-icons>
                  <div class="col-11 overflow-hidden">
                    <h2 class="drug-name--primary truncate-line pt1" id="witnessDiscrepancyDisplayName">
                      {{currentItem.getProductDisplayName()}}
                    </h2>
                    @if (!currentItem.isBinned() && !currentItem.isPatientOwned) {
                      <h2 class="drug-name--alternate truncate-line" id="alternateName">
                        {{currentItem.alternateName}}
                      </h2>
                    }
                    @if (currentItem.isPatientOwned) {
                      <h2 class="drug-name--alternate truncate-line" id="patientOwnedItemInfo">
                        <div id="witnessItemPatientOwnedInfo">
                          <span class="h6 bold gray-15" id="patientOwnedItemTypeShortName">{{currentItem.patientOwnedItemTypeShortName}}</span>
                          {{patientOwnedDemographics}}
                        </div>
                      </h2>
                    }
                    <div class="flex justify-content-between">
                      <absg-status-pills id="witnessDiscrepancyWitnessPill" [customId]="000" [statusProvider]="currentItem" [isWitness]="true"
                        [suppressDiscontinuedItem]="currentItem?.isBinItem" [suppress505b2Pill]="currentItem?.isBinItem"
                        [suppress340BPill]="currentItem?.isBinItem" [suppressBuyInPill]="currentItem?.isBinItem">
                      </absg-status-pills>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-4 pr0 border-left border-navy-87 flex flex-column justify-content-around">
                <table class="table without-outer-border without-inner-border has-xs-rows gray-62">
                  <tbody>
                    <tr>
                      <td class="right normal gray-62" id="lblQOHBefore">{{qohBeforeAfterText}}</td>
                      <td class="right h3" id="qohBefore">{{getQOH()}} {{currentItem.inventoryUnitOfMeasure}}</td>
                    </tr>
                    <tr>
                      <td class="right normal gray-62 red" id="lblQOHEntered">QOH Entered</td>
                      <td class="right h3 red" id="qohEntered">{{getQOHEntered()}}
                        {{currentItem.inventoryUnitOfMeasure}}
                      </td>
                    </tr>
                    @if (isCurrentItemNDCOutOfStock) {
                      <tr>
                        <td id="lblSelectedBinItemNDCQoh" class="right normal gray-62 red">QOH of Selected</td>
                        <td id="selectedBinItemNDCQoh" class="right h3 red">0 {{currentItem.inventoryUnitOfMeasure}}</td>
                      </tr>
                    }
                    <tr>
                      <td colspan="2" class="right normal red" id="lblQOHChanged">{{getQohChangedText()}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal__body bg-white border-top border-bottom border-navy-87 pb3">
          <div class="h5 gray-40 pb1 required-label" id="lblDiscrepencyNotes">The QOH has been updated. Enter discrepancy notes below.
          </div>
          <div class="container">
            <div class="row no-edge-gutters">
              <div class="col-12">
                <textarea id="txtDiscrepancyNotes" absgReplaceSpecialCharacter #txtDiscrepancyNotes rows="2" class="form-control required"
                  maxlength="140" [formControl]="discrepancyNotes" (keydown)="onKeyDown($event)" (keyup)="onKeyUp()"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal__footer flex-column">
          <div class="flex align-center justify-content-between">
            <div class="flex align-center ">
              @if ((currentItem.skipTransaction)) {
                <div class="mr2 ">
                  <svg id="wdWarning" class="height-4 width-4 fill-danger-core">
                    <use xlink:href="./assets/icons/connect-icons.svg#Warning"></use>
                  </svg>
                </div>
                <div class="">
                  <div class="h3 gray-40">Warning</div>
                  <div class="h4 gray-40" id="divDynamicMessageFirstLine">{{getDynamicMessageFirstLine()}}</div>
                  <div class="h4 gray-40" id="divDynamicMessageSecondLine" [innerHtml]="getDynamicMessageSecondLine()">
                  </div>
                </div>
              }
            </div>
            <div class="flex justify-content-end">
              <div class="flex">
                @if ((currentItem.skipTransaction)) {
                  <button class="btn btn--true-blue" id="btnWitnessDiscrepancySaveAndSkip" #btnWitnessDiscrepancySaveAndSkip
                    [disabled]="!(isButtonsEnabled()) || isSpinnerVisible" (click)="saveAndSkipDiscrepancy()">Save and Skip Item</button>
                } @else {
                  <button class="btn btn--true-blue" id="btnWitnessDiscrepancySaveAndContinue" #btnWitnessDiscrepancySaveAndContinue
                    [disabled]="!(isButtonsEnabled()) || isSpinnerVisible" (click)="saveAndContinueDiscrepancy()">{{saveButtonText}}</button>
                }
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  }
</div>
